import { useTranslation } from "react-i18next";

import StudyDocumentsTab from "@/pages/documents/components/StudyDocumentsTab";
import StudySourceLayout from "@/components/layout/StudySourceLayout";
import OpsMateRouteShell from "@/pages/opsmate/components/OpsMateRouteShell";

function DocumentsInOpsMateInner() {
  const { i18n } = useTranslation();
  const isZh = i18n.language === "zh";

  return (
    <OpsMateRouteShell>
      <div className="flex flex-col h-full overflow-hidden bg-gray-50/60 rounded-xl">
        <div className="bg-white px-6 py-4 border-b border-gray-100">
          <div className="flex items-start justify-between">
            <div>
              <h1 className="text-xl font-bold text-gray-900">
                {isZh ? "Study Source" : "Study Source"}
              </h1>
              <p className="text-sm text-gray-500 mt-0.5">
                {isZh
                  ? "查看你已分配或作为成员的 Study Source 与配置路径"
                  : "View Study Sources and configured paths assigned to you or where you are a member"}
              </p>
            </div>
          </div>

          <div className="flex items-end gap-0 mt-4 -mb-4">
            <div
              className="flex items-center gap-2 py-2.5 px-5 text-sm font-semibold whitespace-nowrap border-b-2"
              style={{ borderBottomColor: "#830051", color: "#830051" }}
            >
              <i className="ri-microsoft-line text-base" />
              <span>Study Sources</span>
            </div>
          </div>
        </div>

        <div className="flex flex-1 overflow-hidden bg-white">
          <StudyDocumentsTab isZh={isZh} />
        </div>
      </div>
    </OpsMateRouteShell>
  );
}

export default function DocumentsInOpsMatePage() {
  return <DocumentsInOpsMateInner />;
}
